/**
 * Marks a string as a translation key so `npm run i18n:extract` adds it to the catalogs. Returns
 * its argument unchanged; it does not translate.
 *
 * Use it where a literal is defined in one place and translated somewhere else, e.g. a menu title
 * passed to a helper that later calls `translate(title)`:
 *
 *     createMenuItem(marker('Site Notifications'), 'home.admin.sitenotification', 'glyph-img-notification')
 *
 * The extractor finds the calls by the import path, so keep the module name and the `marker`
 * export name as they are (see docs/GFORGE-I18N.md).
 */
export function marker<T extends string | string[]>(key: T): T {
    return key;
}
